// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__36ZBZ","dragIcon":"SortableItem_dragIcon__3hCJh","disabled":"SortableItem_disabled__2UoT-"};